import { lazy, LazyExoticComponent } from "react";

const HomePage = lazy(() => import("pages/HomePage"));
const DebugPage = lazy(() => import("pages/DebugPage"));
const ClassesPage = lazy(() => import("pages/ClassesPage"));
const LoginPage = lazy(() => import("pages/account/LoginPage"));

export const RouteList = {
    Home: "/",
    Login: "/login",
    Classes: "/classes",
    Debug: "/debug",
};

interface IRouteTableItem {
    path: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Component: LazyExoticComponent<any>;
}

export const RouteTable: Array<IRouteTableItem> = [
    { path: RouteList.Home, Component: HomePage },
    { path: RouteList.Login, Component: LoginPage },
    { path: RouteList.Classes, Component: ClassesPage },
    { path: RouteList.Debug, Component: DebugPage },
];

export const Redirects: Map<string, string> = new Map([]);

export const RouteLink = {};
